module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5RRG6"))).then(() => parcelRequire('d0iPb'));